import { type ReactNode } from 'react';
import { ItemsTable } from 'receivable-invoices-js/react/components/items-table';
import { ReceivableInvoicesActions } from 'receivable-invoices-js/react/components/receivable-invoices/actions';
import { CheckoutSection } from 'receivable-invoices-js/react/components/receivable-invoices/checkout-section';
import type { ReceivableInvoice } from 'receivable-invoices-js/react/api/models/receivable-invoice';
import type { PaymentLink } from 'receivable-invoices-js/react/api/models/payment-link';
import type { PaymentPollingStatus } from 'receivable-invoices-js/react/routes/invoices/index/hooks/use-status-polling';
import styles from '../responsive-view.module.css';

interface PaymentLinkContentProps {
  document: ReceivableInvoice;
  paymentLink?: PaymentLink | null;
  paymentPollingStatus?: PaymentPollingStatus;
  clientPortalId?: string;
  downloadAll: () => Promise<void>;
  hasAttachments: boolean;
  isClientPortalEnabled?: boolean;
}

export function PaymentLinkContent({
  document,
  paymentLink,
  paymentPollingStatus,
  clientPortalId,
  downloadAll,
  hasAttachments,
  isClientPortalEnabled,
}: PaymentLinkContentProps): ReactNode {
  if (!paymentLink) return null;

  return (
    <CheckoutSection
      className={styles.details}
      clientId={clientPortalId}
      data-test-payment-link-checkout-section
      document={document}
      downloadAll={downloadAll}
      hasAttachments={hasAttachments}
      isClientPortalEnabled={isClientPortalEnabled}
      paymentLink={paymentLink}
      paymentPollingStatus={paymentPollingStatus}
    >
      <div className={styles.paymentLinkDetails}>
        <ReceivableInvoicesActions
          className={styles.actions}
          clientPortalId={clientPortalId}
          data-test-payment-link-actions
          downloadAll={downloadAll}
          hasAttachments={hasAttachments}
          hideDownloadButton={!document.pdfUrl}
          invoiceId={document.id}
          invoiceStatus={document.status}
          isClientPortalEnabled={isClientPortalEnabled}
          isImported={Boolean(document.isImported)}
          pdfUrl={document.pdfUrl || ''}
          sddEnabled={document.directDebitEnabled || false}
          showClientPortalCTA={false}
          showPayCTA={false}
        />
        <ItemsTable
          className={styles.itemsTable}
          data-test-payment-link-items-table
          sections={document.sections}
        />
      </div>
    </CheckoutSection>
  );
}
